import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { ARTICLES } from "../data/articles";

const Blog = () => (
  <>
    <Seo
      title="Blog — Conseils revêtements de sols | Resineko"
      description="Conseils et guides Resineko : prix d'un sol en résine, résine époxy ou béton ciré, revêtement de garage, moquette de pierre pour piscine, entretien…"
      path="/blog"
    />
    <PageHero
      kicker="Le journal Resineko"
      title="Conseils & guides revêtements"
      subtitle="Des réponses claires aux vraies questions : prix, choix des matériaux, entretien, préparation des supports."
      image="/images/hero-main.jpg"
      dim
    />

    <section className="bg-[#0A0A0A] py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.05}>
              <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group flex h-full flex-col border border-white/10 bg-[#111] transition-colors duration-300 hover:border-[#047857]/50">
                <div className="overflow-hidden">
                  <img src={a.image} alt={a.title} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-[#2FBF8F]">{a.category} — {a.readTime}</p>
                  <h2 className="mt-3 font-serif text-2xl font-light leading-snug text-[#F4F4F0] transition-colors group-hover:text-[#2FBF8F]">{a.title}</h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-[#8C8C8C]">{a.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.2em] text-[#F4F4F0]/60 transition-colors group-hover:text-[#2FBF8F]">
                    Lire l'article <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-14 max-w-2xl border-l-2 border-[#047857] pl-5 text-sm leading-relaxed text-[#8C8C8C]">
            De nouveaux guides sont publiés régulièrement : sol industriel, terrasse, rénovation d'un sol ancien, choix des couleurs… Une question précise ? <Link to="/contact" className="text-[#2FBF8F] underline-offset-4 hover:underline">Écrivez-nous</Link>.
          </p>
        </Reveal>
      </div>
    </section>

    <CTASection />
  </>
);

export default Blog;
